import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * FundInvestor API
 */
class UserNotificationApi extends ApiBase {
  /**
   * update usernotifications
   * @param {*} usernotifications
   * @param userId
   */
  async update(usernotifications, userId) {
    const request = {
      url: `${this.API_URL}/usernotifications/?userId=${userId}`,
      headers: this.getHeaders(),
      method: 'PUT',
      data: JSON.stringify(usernotifications)
    };

    const response = await axios.request(request);

    return response.data;
  }
}

export default new UserNotificationApi();
